import firebase from 'firebase';
import config from '../config.json';

// Initialize Firebase
firebase.initializeApp(config.firebase);
const auth = firebase.auth();
const messaging = firebase.messaging();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.database();

const getFCMToken = async () => {
  return await messaging.getToken({ vapidKey: 'BI84rNT_wpR3XJRfv8ttcRUNZRPN62mk8TraWi-ujDLGYHzE0ObSlIQOpDl3F0NKWZVrkXW63cctFROzxvDwLzs' });
}

export {
  database,
  auth,
  messaging,
  getFCMToken,
  googleAuthProvider,
  facebookAuthProvider,
  githubAuthProvider,
  twitterAuthProvider
};
